import React from 'react';
import { formatContractSumDisplay } from '../utils/table';

interface BudgetProgressBarProps {
  plan: number | null;
  remainder: number | null;
}

const BAR_HEIGHT = 36;
const BAR_WIDTH = 10;

const BudgetProgressBar: React.FC<BudgetProgressBarProps> = ({ plan, remainder }) => {
  const planVal = plan != null && plan > 0 ? plan : null;
  const remainderVal = remainder ?? 0;

  if (planVal == null) {
    return (
      <div className="contract-detail__budget-column-wrap" aria-hidden>
        <div
          className="contract-detail__budget-column-plan contract-detail__budget-column-plan--empty"
          style={{ height: BAR_HEIGHT, width: BAR_WIDTH }}
          title="План бюджета не задан"
        />
      </div>
    );
  }

  const positiveRemainder = remainderVal > 0;
  const overrun = remainderVal < 0;

  const remainderHeight = positiveRemainder
    ? Math.max(4, Math.min(BAR_HEIGHT, Math.round((remainderVal / planVal) * BAR_HEIGHT)))
    : 0;

  const overrunHeight = overrun
    ? Math.max(4, Math.min(BAR_HEIGHT, Math.round((Math.abs(remainderVal) / planVal) * BAR_HEIGHT)))
    : 0;

  return (
    <div className="contract-detail__budget-column-wrap" aria-hidden>
      <div
        className="contract-detail__budget-column-plan"
        style={{ height: BAR_HEIGHT, width: BAR_WIDTH }}
        title={`План: ${formatContractSumDisplay(planVal)}, остаток: ${formatContractSumDisplay(remainderVal)}`}
      >
        {positiveRemainder ? (
          <div
            className="contract-detail__budget-column-remainder"
            style={{ height: remainderHeight }}
          />
        ) : null}
      </div>
      {overrun ? (
        <div
          className="contract-detail__budget-column-overrun"
          style={{ height: overrunHeight, width: BAR_WIDTH }}
          title={`Перерасход: ${formatContractSumDisplay(Math.abs(remainderVal))}`}
        />
      ) : null}
    </div>
  );
};

export default BudgetProgressBar;
